<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
            <el-form-item label="归还时间" prop="fzrdh">
                <el-date-picker v-model="from.ssdz" type="date" placeholder="请选择" style="width: 100%;">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="是否有损坏" prop="fzrdh">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="ssdz">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="from.ssmc">
                </el-input>
            </el-form-item>

            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                from: {
                    xmid: "",
                    ssmc: "",
                    ssdz: "",
                    fzrid: "",
                    fzrdh: ""
                }
            };
        },
        methods: {
            Return() {
                this.$parent.$parent.Return();
            },
            Add() {
                this.Return();
            }
        },
        created() {

        }
    }
</script>

<style scoped="scoped">
    >>>.el-textarea__inner:focus {
        border: 1px solid #006e4b;
    }
</style>



// WEBPACK FOOTER //
// WpghGl_edit.vue?98507310